import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Mappa dei codici errore ai label leggibili.
 * Copre tutte le ErrorKey di redirectToOperatorUtils definite nel modulo Errors.
 */
const LABEL_HANDLED_ERROR = {
  aeroportoIATAnotFound: t.errAeroportoIATAnotFound,
  attachmentsInEmail: t.errAttachmentsInEmail,
  destinationHotelNotFound: t.errDestinationHotelNotFound,
  duplicazioneProfiloTrovato: t.errDuplicazioneProfiloTrovato,
  erroreCreazioneTrasferta: t.errErroreCreazioneTrasferta,
  erroreCreazioneServizi: t.errErroreCreazioneServizi,
  erroreCreazionePreventivi: t.errErroreCreazionePreventivi,
  erroreElaborazioneServizi: t.errErroreElaborazioneServizi,
  erroreRicercaDinamico: t.errErroreRicercaDinamico,
  erroreRicercaDinamicoVuoto: t.errErroreRicercaDinamicoVuoto,
  emailMancanteProfiloViaggiatore: t.errEmailMancanteProfiloViaggiatore,
  genericError: t.errGenericError,
  loopError: t.errLoopError,
  nessunProfiloTrovato: t.errNessunProfiloTrovato,
  nessunProfiloTrovatoTA: t.errNessunProfiloTrovatoTA,
  profiloMittenteNonTA: t.errProfiloMittenteNonTA,
  noFinalizzazioneCorretta: t.errNoFinalizzazioneCorretta,
  noKeyServizioGenerato: t.errNoKeyServizioGenerato,
  noProfileInfoTrovato: t.errNoProfileInfoTrovato,
  nonTrovatoRiferimentoServizioSuMidOffice: t.errNonTrovatoRiferimentoServizioSuMidOffice,
  passeggeriMultipli: t.errPasseggeriMultipli,
  profiloNoPresenteSuGDS: t.errProfiloNoPresenteSuGDS,
  richiestaModificaOCancellazioneTrasferta: t.errRichiestaModificaOCancellazioneTrasferta,
  richiestaAggiornamentoTrasferta: t.errRichiestaAggiornamentoTrasferta,
  tooManyMessages: t.errTooManyMessages,
  tooMuchServiceBoth: t.errTooMuchServiceBoth,
  tooMuchServicePlane: t.errTooMuchServicePlane,
  tooMuchServiceTrain: t.errTooMuchServiceTrain,
  noAirportFound: t.errNoAirportFound,
  tooManyDaysHotel: t.errTooManyDaysHotel,
  noNoraTransfer: t.errNoNoraTransfer,
  moreThanOneTransfer: t.errMoreThanOneTransfer,
  carnetError: t.errCarnetError,
  noTransferFound: t.errNoTransferFound,
  outOfOffice: t.errOutOfOffice,
  sollecito: t.errSollecito,
  maxAIMessagesReachedInGC: t.errMaxAIMessagesReachedInGC,
  departureCarJsonNotFound: t.errDepartureCarJsonNotFound,
  errorSavingAttachments: t.errErrorSavingAttachments,
  canceled: t.errCanceled,
  default: t.errDefault
}

/**
 * Componente per la visualizzazione dettagliata degli errori gestiti.
 * Mostra ogni tipologia di errore con barra proporzionale, conteggio e percentuale.
 * @param {Object} props - Proprietà del componente
 * @param {Array} props.errorHandled - Array delle conversazioni con errori gestiti
 * @returns {JSX.Element} Lista breakdown errori gestiti
 */
export const DetailsErrorHandled = ({ errorHandled }) => {
  const totale = errorHandled.length

  if (!totale) return null

  const updateErrorHandled = errorHandled?.map((item) => {
    if (item.status === 'canceled') {
      item.errorCode = 'canceled'
    }
    return item
  })

  const raggruppati = updateErrorHandled.reduce((acc, curr) => {
    const codice = curr.errorCode
    if (!acc[codice]) {
      acc[codice] = { perc: 0, data: [] }
    }
    acc[codice].data.push(curr)
    return acc
  }, {})

  for (const codice in raggruppati) {
    const count = raggruppati[codice].data.length
    raggruppati[codice].perc = parseFloat(((count / totale) * 100).toFixed(2))
  }

  const sorted = Object.keys(raggruppati).sort((a, b) => raggruppati[b].perc - raggruppati[a].perc)

  return (
    <>
      {sorted.map((key) => {
        const item = raggruppati[key]
        return (
          <div className="stats-progress-row" key={key}>
            <div className="stats-progress-labels">
              <span className="stats-progress-name">
                {LABEL_HANDLED_ERROR[key] || LABEL_HANDLED_ERROR.default}
              </span>
              <span
                className="stats-progress-value"
                style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: 'var(--ink-900)' }}
              >
                {item.perc}%
                <span style={{ color: 'var(--ink-500)', fontWeight: 400 }}>
                  {' '}
                  · {item.data.length}
                </span>
              </span>
            </div>
            <div className="stats-progress-track">
              <div
                className="stats-progress-fill"
                style={{ width: `${Math.min(item.perc, 100)}%`, background: 'var(--info)' }}
              />
            </div>
          </div>
        )
      })}
    </>
  )
}
